import { AnnouncementType } from "oneclick-component/src/store/apis/enhancedApi";

export const announcementTypeTitleI18nKeyMap: Record<AnnouncementType, string> =
  {
    FRIENDLY_REMINDER: "announcement.friendlyReminder.defaultTitle",
    IMPORTANT: "announcement.important.defaultTitle",
  };
